import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  buttonStyle: {
    margin: "5px 1rem 0 0",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
    },
  },
  datePickerParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:834px)": {
      display: "block",
    },
  },
  popOverCard: {
    "@media (max-width:992px)": {
      left: "250px !important",
    },
    "@media (max-width:600px)": {
      left: "18px !important",
    },
    "@media (max-width:360px)": {
      left: "0px !important",
    },
  },
  buttonsParent: {
    borderRight: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "column",
    padding: "0 10px 0 0",
    "@media (max-width:834px)": {
      borderRight: "none",
    },
  },
  datePickerParentDiv: {
    // padding: "10px 0 10px 0",
  },
  datePicker: {
    padding: "0 10px 0 10px",
  },
  
  dateButtons: {
    width: "auto",
    marginTop: "12px",
    transition: "0.5s",
    backgroundColor: "transparent",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
      color: "var(--app-text)",
    },
    color: "var(--app-text)",
    "@media (max-width:834px)": {
      backgroundColor: "var(--app-primary)",
      color: "var(--app-on-primary)",
    },
  },
  activeButton: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
      color: "var(--app-on-primary)",
    },
  },
  bottomButtonsParent: {
    borderTop: "1px solid var(--app-border)",
    paddingTop: "10px",
  },
  bottomButtons: {
    marginLeft: "15px",
  },
  cancelButton: {
    backgroundColor: "var(--app-surface-2)",
    color: "var(--app-text)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  applyButton: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    width: "55%",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  iconCalendar: {
    margin: "0 10px 0 0",
  },
}));

export default useStyles;
